import { createContext, type Dispatch, type SetStateAction } from 'react'
import type { ChatMessage, ModelKey, ReviewMode } from '../types'

export interface ChatSessionValue {
  messages: ChatMessage[]
  isLoading: boolean
  selectedModel: ModelKey
  setSelectedModel: (model: ModelKey) => void
  draftMessage: string
  setDraftMessage: (content: string) => void
  sendMessage: (content: string, model?: ModelKey, onSendFailed?: () => void) => void
  undoSend: () => string | null
  resetChatSession: () => void
  deleteMessage: (id: string) => void
  reviewMode: ReviewMode | null
  setReviewMode: (reviewMode: ReviewMode | null) => void
  isCommentMode: boolean
  setIsCommentMode: Dispatch<SetStateAction<boolean>>
  includeComments: boolean
  setIncludeComments: Dispatch<SetStateAction<boolean>>
  isContextBarExpanded: boolean
  setIsContextBarExpanded: Dispatch<SetStateAction<boolean>>
  systemPrompt: string
  setSystemPrompt: (systemPrompt: string) => void
  setRequiresFullDocument: (value: boolean) => void
  clearMessages: () => void
  clearAgentSession: () => void
  keepMessageOnSend: boolean
  setKeepMessageOnSend: (value: boolean) => void
}

export const ChatSessionContext = createContext<ChatSessionValue | undefined>(undefined)
